export const EnChatroomStrings = {
  SETTINGS: "Settings",
  PHOTO: "Photo",
  VIDEO: "Video",
  DOCUMENT: "Document",
  MESSAGE_STAR: 'Starred Messages',

  EXPORT_CHAT: {
    TITLE: "Export chat messages",
    CHAT: "Chat: ",
    TIME: "Time: ",
    CHAT_INFO: "Export chat messages of chat: ",
    EXPORT_TIME_PERIOD: "Time period",
    RANGE_SELECT_MSG: "Please select a time period. Messages within this time period will be exported.",
    NO_TIME_PERIOD_ERROR_MSG: "Please select a time period",
    CONFIRM_MSG: "Are you sure to export messages from {{FROM}} to {{TO}}?",
    IN_PROGRESS_MSG: "Chat messages are exporting, you can check the progress in notification center at the top-right hand corner. You will be notified when the file is ready.",
    EXPORT_DONE_DOWNLOAD: "Done. Please click here to download.",
    EXPORT_READY_MSG: "Chat messages file is ready, you can download it in notification center.",
    EXPORT_WITH_WATERMARK: {
      TITLE: "Add watermark on attachments? ",
      TIP: "(Exporting with watermark will include photos only)"
    }
  },

  SEND: "Send",
  TEXTAREA_PLACEHOLDER: {
    IE: "Input message / Drag & Drop file here",
    OTHERS: "Input message / Paste image / Drag & Drop file here",
    TEXT_ONLY: "Input message",
    DROP_FILE_TIPS: "Drop file here"
  },
  MESSAGE_OPTION: {
    UPLOAD: "Upload",
    LOCATION: "Location",
    ATTACH: "Attach",
    EXIT_EDIT: "Exit Edit Mode",
    IMPORTANT: "Important",
    SMS: "SMS",
    SELECT_FROM_DOCUMENT_SHARING: "Select from Document Sharing",
    POLL: "Poll"
  },

  WHISPER: "Whisper",
  NAME_WHISPER_LABEL: "{{USER}} (whisper)",

  READ: "Read",
  READ_GROUP: "Read {{NUM}}",

  EDITED: "Edited",

  NEW_MESSAGE: {
    ONE: "New Message ({{NUM}})",
    MULTIPLE: "New Messages ({{NUM}})"
  },
  UNREAD_MESSAGE_HEADER: "UNREAD MESSAGES",

  ONLINE: "Online",
  LAST_SEEN: "Last seen at ",
  NOT_EXIST: "Chatroom does not exist",
  
  JOIN_CHAT: "{{ACTOR}} added {{USERS}} to the group",
  LEAVE_GROUP: "{{USERS}} left the group",
  ADMIN_CHANGE: {
    ONE: "{{USER}} is now group admin",
    MULTIPLE: "{{USERS}} are now group admins"
  },
  ADMIN_REMOVED: {
    ONE: "{{USER}} is no longer a group admin",
    MULTIPLE: "{{USERS}} are no longer group admins"
  },
  MESSAGE_RECALLED: {
    ME: "You recalled a message",
    OTHERS: "{{USER}} recalled a message"
  },

  CLASSIFICATION_LEVEL: {
    AUTH_TITLE: "You are entering a Confidential chat room. Messages will be deleted when you leave the chat room. Please authenticate again to accept and enter the chatroom.",
    DESC: "Messages classified as: ",
    LEVEL0: "Normal",
    LEVEL1: "Internal", // origin: Restricted
    LEVEL2: "Restricted" // origin: Confidential
  },

  ENCRYPTED_MESSAGE: {
    AUTH_TITLE: "Please authenticate before viewing secure messages",
    MESSAGE_PREVIEW: "Secure message, press to view",
    STARRED_MESSAGE_PREVIEW: "Secure message, please view in the chatroom"
  },

  CRITICAL_MESSAGE: {
    SEND_WARNING: "CRITICAL NOTIFICATION: Important message pending for all users in this group. This message will be sent with a compulsory alarm and notification. Please confirm if you wish to proceed with sending this critical message.",
    EXPORT: {
      TITLE: "Export critial message",
      EXPORT_FINISH_TIME: "Exported time: ",
      EXPORT_READY_MSG: "Critical message file is ready, you can download it in notification center.",
      IN_PROGRESS_MSG: "Critical message are exporting, you can check the progress in notification center at the top-right hand corner. You will be notified when the file is ready.",
    }
  },

  OUT_OF_OFFICE: {
    UNTIL: "Out of office until ",
    COUNT: {
      ONE: "{{NUM}} people is out of office",
      MULTIPLE: "{{NUM}} people are out of office"
    }
  },

  REPLY: {
    YOU: "You",
    IMAGE: "Image",
    VIDEO: "Video",
    AUDIO: "Voice Message",
    DOCUMENT: "Document",
    LOCATION: "Location",
    STICKER: "Sticker"
  },

  GROUP_INFO_ITEM: {
    ADMIN: "Group Admin",
    OUT_OF_OFFICE: "Out of office"
  },

  MESSAGE_OPTIONS: {
    INFO: "Message info",
    ACKNOWLEDGEMENT_INFO: 'Message report status',
    FORWARD: "Forward",
    // SELECT: "Select Message(s)",
    SELECT: "Forward",
    DOWNLOAD: "Download",
    RECALL: "Recall message",
    REPLY: "Reply",
    EDIT: "Edit",
    REPORT: "Report",
    STAR: 'Star message',
    UNSTAR: 'Unstar message',
    PIN: 'Pin message',
    UNPIN: 'Unpin message',
    COPY: 'Copy',
    EMOJI: 'Send emoji',
    DELETE: "Delete",
    EXPORT_CRITICAL_MSG: "Export message",
  },

  EMOJI_INFO: {
    TITLE: "Emoji Details",
    PREVIEW_TITLE: "All {{emoji_count}} emoji(s)"
  },

  MESSAGE_INFO: {
    TITLE: "Message Info",
    READ_HEADER: "Read by",
    DELIVERY_HEADER: "Delivered to",
    UNREAD_HEADER: "Unread",
    ACKNOWLEDGED_HEADER: 'Acknowledged',
    SMS_HEADER: "SMS Status"
  },

  RECALL: {
    SUCCESS: "Message recalled successfully",
    FAIL: "Message recalled failed"
  },

  FORWARD: {
    CONFIRM_MSG: "Confirm forward message to {{chat}}?",
    SUCCESS_MSG: "Messages forwarded"
  },

  DELETE: {
    CONFIRM_MSG: "Delete this message?"
  },

  ACK: {
    ACKED: "Acknowledged",
    ACK: "Acknowledge"
  },

  FALLBACK_STATUS: {
    PENDING: 'Pending',
    SENT: 'Sent',
    ERROR: 'Error'
  },

  POLL: {
    CREATE_TITLE: "Create poll",
    QUESTION_LABEL: "QUESTION",
    TITLE_PLACEHOLDER: "Ask question",
    OPTIONS_LABEL: "OPTIONS",
    OPTION_PLACEHOLDER: "Add",
    ADD_OPTION: "Add option",
    ALLOW_MULTIPLE_CHOICE: "Allow multiple answers",
    DISPLAY_RESULT_LABEL: "Show results",
    DISPLAY_RESULT_OPTIONS: {
      ALWAYS: "Always",
      NEVER: "Never",
      AFTER_VOTE_END: "After vote end",
      AFTER_USER_VOTE: "After user vote"
    },
    END_TIME_TOGGLE: "Set an end time",
    END_TIME_HINT_NO_END_TIME: "Results will show when you end this poll",
    CREATE_BUTTON: "Send",
    SELECT_ONE_HINT: "Select one",
    MULTIPLE_CHOICE_HINT: "Select one or more",
    VOTES_COUNT: {
      ONE: "{{COUNT}} vote",
      MULTIPLE: "{{COUNT}} votes"
    },
    ENDED: "Poll ended",
    END_BUTTON: "End poll",
    END_CONFIRM: "End this poll now? No more votes can be cast.",
    ALREADY_ENDED: "This poll has already ended.",
    VIEW_VOTES: "View votes",
    DETAIL_TITLE: "Poll votes",
    VOTER_YOU: "You",
    VOTED_TODAY: "today",
    VOTED_YESTERDAY: "yesterday",
    NO_VOTES_YET: "No votes yet",
    ERROR: {
      TITLE_REQUIRED: "Please input the question and at least two options",
      TITLE_TOO_LONG: "Question must be at most 255 characters",
      OPTIONS_MIN: "Please input the question and at least two options",
      OPTIONS_MAX: "A poll can have at most 12 options",
      OPTION_EMPTY: "Please input the question and at least two options",
      OPTION_TOO_LONG: "Each option must be at most 100 characters",
      END_TIME_INVALID: "Invalid end time",
      END_TIME_PAST: "The end time has already passed. Please pick a later one."
    }
  },

  PINNED_MESSAGE: {
    LIST_TITLE: "Pinned Messages",
    PINNED_BY: "Pinned by {{USER}}",
    EMPTY: "No pinned messages",
    UNPIN_CONFIRM_MSG: "Unpin this message?"
  },

  VIDEO_CALL: {
    INCOMING_CALL: 'Incoming call',
    JOIN: 'Join',
    IN_CALL: 'In Call',
    CALL_ENDED: 'Call Ended',
    WAITING_TO_JOIN: 'Waiting for users to join',
    TURNED_OFF_CAM: 'You turned off the webcam',
    START_CALL_CONFIRM_MSG: 'Start a video call?',
    END_CALL_CONFIRM_MSG: 'End the current video call?',
    END_CALL_BEFORE_LEAVING: 'Please end the call before going to another page.'
  }
}
